import { page as pageIndex } from '../../globals'
import {
  actionHandler,
  UPDATE_DATA
} from './updateData'
// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [UPDATE_DATA] : (state, action) => action.location.page !== pageIndex.dashboard
   ? state
   : action.location.section !== 'deletedRecords' ? null : actionHandler(state, action)
}
// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  isFetchingData: true,
  errorCode: '',
  renderData: {},
  formDataValue: {
    D: {
      archivedYear: {
        radio: {
          archivedYear: ''
        }
      },
      deletedRecords: {
        selected: []
      }
    }
  }
}
export default function deletedRecordsReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/reducers/deletedRecordsArchive.js